import { __decorate } from "tslib";
import React, { isValidElement } from 'react';
import { observer } from 'mobx-react';
import Icon from 'choerodon-ui/lib/icon';
import warning from 'choerodon-ui/lib/_util/warning';
import { action, computed, isArrayLike, observable, runInAction, toJS } from 'mobx';
import isNumber from 'lodash/isNumber';
import isNil from 'lodash/isNil';
import noop from 'lodash/noop';
import isPlainObject from 'lodash/isPlainObject';
import { isMoment } from 'moment';
import defaultTo from 'lodash/defaultTo';
import Row from 'choerodon-ui/lib/row';
import classNames from 'classnames';
import * as ObjectChainValue from '../_util/ObjectChainValue';
import DataSetComponent from '../data-set/DataSetComponent';
import ScreeningOption from './ScreeningOption';
import normalizeOptions from '../option/normalizeOptions';
import autobind from '../_util/autobind';
import isEmpty from '../_util/isEmpty';
import { getDateFormatByField, toMultipleValue } from '../field/utils';
import { FieldType } from '../data-set/enum';
import { formatString } from '../formatter';
import isSame from '../_util/isSame';
import isSameLike from '../_util/isSameLike';
import ObserverButton from '../button/Button';
import { $l } from '../locale-context';
const disabledField = '__disabled';
const expandedButton = (iconExpanded) => {
    if (iconExpanded === true) {
        return (React.createElement(React.Fragment, null,
            React.createElement("span", null, `${$l('Screening', 'pack_up')}`),
            React.createElement(Icon, { type: "expand_less" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("span", null, `${$l('Screening', 'more')}`),
        React.createElement(Icon, { type: "expand_more" })));
};
export function getItemKey(record, text, value) {
    return `item-${value || record.id}-${(isValidElement(text) ? text.key : text) || record.id}`;
}
function getSimpleValue(value, valueField) {
    if (isPlainObject(value)) {
        return ObjectChainValue.get(value, valueField);
    }
    return value;
}
let Screening = class Screening extends DataSetComponent {
    constructor(props, context) {
        super(props, context);
        this.emptyValue = null;
        this.text = null;
        this.handleExpanedClick = () => {
            this.iconExpanded = !this.iconExpanded;
        };
        /**
         * 提交值，触发dataSet修改和提交方法。
         */
        this.handleConfirm = () => {
            const { onConfirm } = this.props;
            const { value, dataSet, name, observableProps: { dataIndex } } = this;
            if (value && name && dataSet) {
                (this.record || dataSet.create({}, dataIndex)).set(name, value);
                if (onConfirm) {
                    onConfirm({
                        value: this.value,
                        fieldName: this.name,
                    });
                }
            }
        };
        this.handleSelect = (info) => {
            const record = info.value;
            this.choose(record);
        };
        this.handleDeselect = (info) => {
            const record = info.value;
            this.unChoose(record);
        };
        this.handleClick = (_info) => {
        };
        this.getScreeningOption = () => {
            const { colProps, optionRenderer } = this.props;
            const { options, textField, valueField, multiple, } = this;
            if (!options) {
                return null;
            }
            const { data } = options;
            if (!isEmpty(data)) {
                return data.map((record) => {
                    const value = record.get(valueField);
                    const text = record.get(textField);
                    const key = getItemKey(record, text, value);
                    let isSelected = false;
                    const valueRecord = this.processRecordToObject(record);
                    const selectedValue = toJS(this.value);
                    if (multiple) {
                        if (selectedValue && selectedValue.length > 0) {
                            isSelected = selectedValue.some(itemValue => {
                                return isSame(itemValue, valueRecord);
                            });
                        }
                    }
                    else if (isSame(valueRecord, selectedValue)) {
                        isSelected = true;
                    }
                    const textNode = (React.createElement("span", { className: `${this.prefixCls}-option-text` }, text));
                    const screeningOptionProps = {
                        ...colProps,
                        onSelect: this.handleSelect,
                        onDeselect: this.handleDeselect,
                        onClick: this.handleClick,
                        value: record,
                        optionkey: key,
                        multiple,
                        isSelected,
                        prefixCls: this.prefixCls,
                        children: textNode,
                    };
                    if (optionRenderer) {
                        screeningOptionProps.optionRender = optionRenderer({ record, text, value });
                    }
                    return (React.createElement(ScreeningOption, Object.assign({ key: key }, screeningOptionProps)));
                });
            }
            return null;
        };
        this.handleMultiple = () => {
            this.screeningMultiple = !this.screeningMultiple;
        };
        this.handleClear = () => {
            this.setValue(this.emptyValue);
            this.value = this.emptyValue;
            this.text = this.emptyValue;
        };
        this.handleCancel = () => {
            this.handleClear();
            this.handleMultiple();
        };
        runInAction(() => {
            this.iconExpanded = false;
            this.screeningMultiple = false;
            if (this.name && this.dataSet && this.record) {
                const value = this.record.get(this.name);
                if (!isNil(value)) {
                    this.value = value;
                }
            }
        });
    }
    componentDidMount() {
        super.componentDidMount();
        const { onRef } = this.props;
        if (onRef) {
            onRef(this);
        }
    }
    /**
     * return the record: dataIndex record, current, undefined
     */
    get record() {
        const { record, dataSet, dataIndex } = this.observableProps;
        if (record) {
            return record;
        }
        if (dataSet) {
            if (isNumber(dataIndex)) {
                return dataSet.get(dataIndex);
            }
            return dataSet.current;
        }
        return undefined;
    }
    get value() {
        return this.observableProps.value;
    }
    set value(value) {
        runInAction(() => {
            this.observableProps.value = value;
        });
    }
    // @computed
    get editable() {
        return !this.disabled && !this.isReadOnly();
    }
    /**
     * 判断是否展示更多按钮
     */
    get needExpandButton() {
        const { colProps } = this.props;
        if (colProps) {
            const { span } = colProps;
            if (isNumber(span) && span >= 1) {
                const colNumber = 24 / span;
                if (this.options && (this.options.length < colNumber)) {
                    return false;
                }
            }
        }
        return true;
    }
    get name() {
        return this.observableProps.name;
    }
    get primitive() {
        const type = this.getProp('type');
        return this.observableProps.primitiveValue !== false && type !== FieldType.object;
    }
    /**
     * get field message: recordField,dsField,undefined
     */
    get field() {
        const { record, dataSet, name, observableProps } = this;
        const { displayName } = this.constructor;
        if (displayName !== 'Output' && !name) {
            warning(!observableProps.dataSet, `${displayName} with binding DataSet need property name.`);
            warning(!observableProps.record, `${displayName} with binding Record need property name.`);
        }
        if (name) {
            const recordField = record ? record.getField(name) : undefined;
            const dsField = dataSet ? dataSet.getField(name) : undefined;
            if (recordField) {
                return recordField;
            }
            return dsField;
        }
        return undefined;
    }
    getProp(propName) {
        const { field } = this;
        return defaultTo(field && field.get(propName), this.props[propName]);
    }
    handleChange(e) {
        e.preventDefault();
        e.stopPropagation();
    }
    get options() {
        const { field, textField, valueField, multiple, observableProps: { children, options }, } = this;
        return (options ||
            (field && field.options) ||
            normalizeOptions({ textField, valueField, disabledField, multiple, children }));
    }
    get multiple() {
        return toJS(this.screeningMultiple) || !!this.getProp('multiple');
    }
    get textField() {
        return this.getProp('textField') || 'meaning';
    }
    get valueField() {
        return this.getProp('valueField') || 'value';
    }
    getFieldType() {
        const { field } = this;
        return (field && field.get('type')) || FieldType.string;
    }
    getDateFormat() {
        return getDateFormatByField(this.field, this.getFieldType());
    }
    choose(record) {
        if (record) {
            this.handleOptionSelect(record);
        }
    }
    unChoose(record) {
        if (record) {
            this.handleOptionUnSelect(record);
        }
    }
    handleOptionSelect(record) {
        this.prepareSetValue(this.processRecordToObject(record));
    }
    handleOptionUnSelect(record) {
        const { valueField } = this;
        const newValue = record.get(valueField);
        this.removeValue(newValue, -1);
    }
    getDataSetValue() {
        const { record, name } = this;
        if (record) {
            return record.get(name);
        }
    }
    getValue() {
        const { name, multiple } = this;
        if (multiple) {
            return this.value;
        }
        if (this.dataSet && name) {
            return this.getDataSetValue();
        }
        return this.value;
    }
    getValues() {
        return toMultipleValue(this.getValue(), false);
    }
    getOldValue() {
        return this.getValue();
    }
    addValue(...values) {
        if (this.multiple) {
            const oldValues = this.getValues();
            if (values.length) {
                this.setValue([...oldValues, ...values]);
            }
            else if (!oldValues.length) {
                this.setValue(this.emptyValue);
            }
        }
        else {
            this.setValue(values.pop());
        }
    }
    getValueKey(v) {
        if (isArrayLike(v)) {
            return v.join(',');
        }
        return v;
    }
    removeValues(values, index = 0) {
        let repeat;
        this.setValue(values.reduce((oldValues, value) => {
            repeat = 0;
            return oldValues.filter(v => {
                if (this.getValueKey(v) === this.getValueKey(value)) {
                    if (index === -1 || repeat === index) {
                        this.afterRemoveValue(value, repeat++);
                        return false;
                    }
                    repeat++;
                }
                return true;
            });
        }, this.getValues()));
    }
    afterRemoveValue(_value, _repeat) {
    }
    removeValue(value, index = 0) {
        this.removeValues([value], index);
    }
    isReadOnly() {
        return (this.getProp('readOnly') ||
            (!this.props.onChange));
    }
    setValue(value) {
        const { onConfirm } = this.props;
        if (!this.isReadOnly()) {
            if (this.multiple
                ? isArrayLike(value) && !value.length
                : isNil(value) || value === '') {
                value = this.emptyValue;
            }
            const { name, dataSet, observableProps: { dataIndex }, } = this;
            const { onChange = noop } = this.props;
            const { formNode } = this.context;
            const old = this.getOldValue();
            if (dataSet && name && !this.multiple) {
                (this.record || dataSet.create({}, dataIndex)).set(name, value);
            }
            else {
                value = formatString(value, {});
            }
            // 转成实际的数据再进行判断
            if (!isSame(toJS(old), toJS(value))) {
                onChange(value, toJS(old), formNode);
                if (this.multiple && value) {
                    this.text = value.map((item) => {
                        return this.processValue(item);
                    });
                }
                else if (value) {
                    this.text = this.processValue(value);
                    if (onConfirm) {
                        onConfirm({
                            value,
                            fieldName: this.name,
                        });
                    }
                }
            }
            this.value = value;
        }
    }
    prepareSetValue(...value) {
        const values = value.filter(item => !isEmpty(item));
        this.addValue(...values);
    }
    findByValue(value) {
        const { valueField } = this;
        const autoType = this.getProp('type') === FieldType.auto;
        value = getSimpleValue(value, valueField);
        return this.options.find(record => autoType ? isSameLike(record.get(valueField), value) : isSame(record.get(valueField), value));
    }
    processObjectValue(value, textField) {
        if (!isNil(value)) {
            if (isPlainObject(value)) {
                return ObjectChainValue.get(value, textField);
            }
            const found = this.findByValue(value);
            if (found) {
                return found.get(textField);
            }
        }
    }
    processValueNormal(value) {
        if (!isNil(value)) {
            if (isMoment(value)) {
                return value.format(this.getDateFormat());
            }
            return value.toString();
        }
        return '';
    }
    processLookupValue(value) {
        const { field, textField, primitive } = this;
        if (primitive && field && field.lookup) {
            return this.processValueNormal(field.getText(value));
        }
        return this.processValueNormal(this.processObjectValue(value, textField));
    }
    processValue(value) {
        const text = this.processLookupValue(value);
        if (isEmpty(text)) {
            if (isPlainObject(value)) {
                return ObjectChainValue.get(value, this.valueField) || '';
            }
            return this.processValueNormal(value);
        }
        return text;
    }
    processRecordToObject(record) {
        const { primitive, valueField } = this;
        return primitive ? record.get(valueField) : record.toData();
    }
    getTextNode() {
        const text = this.isFocused && this.editable
            ? this.processValue(this.getValue())
            : this.processRenderer(this.getValue());
        return text;
    }
    getText(value) {
        return this.processValue(value);
    }
    processText(value) {
        return value;
    }
    processRenderer(value) {
        const { record, dataSet, props: { renderer, onConfirm }, } = this;
        const text = this.processText(this.getText(value));
        return renderer
            ? renderer({
                options: this.options,
                name: this.name,
                dataSet,
                onConfirm,
                record,
            })
            : text;
    }
    getObservableProps(props, context) {
        return {
            ...super.getObservableProps(props, context),
            name: props.name,
            record: 'record' in props ? props.record : context.record,
            dataSet: 'dataSet' in props ? props.dataSet : context.dataSet,
            dataIndex: defaultTo(props.dataIndex, context.dataIndex),
            value: this.observableProps || 'value' in props ? props.value : props.defaultValue,
            primitiveValue: props.primitiveValue,
        };
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'record',
            'defaultValue',
            'dataIndex',
            'onEnterDown',
            'onClear',
            'readOnly',
            'renderer',
            'pristine',
            'primitiveValue',
            'trim',
            'onRef',
            'onConfirm',
            'colProps',
        ]);
    }
    getOtherProps() {
        const otherProps = super.getOtherProps();
        otherProps.onChange = this.disabled ? noop : this.handleChange;
        return otherProps;
    }
    getLabel() {
        return this.getProp('label');
    }
    render() {
        const { iconExpanded, prefixCls, multiple } = this;
        const { renderer, onConfirm } = this.props;
        const label = this.getLabel();
        const multipleButton = (React.createElement("div", { className: `${prefixCls}-multiple`, onClick: this.handleMultiple },
            React.createElement(Icon, { type: "add" }),
            React.createElement("span", null, `${$l('Screening', 'multi_select')}`)));
        const expandButtonContainer = this.needExpandButton && (React.createElement("div", { className: `${prefixCls}-expanded`, onClick: this.handleExpanedClick }, expandedButton(iconExpanded)));
        const labelNode = (React.createElement("span", { className: `${prefixCls}-label` }, `${label}:`));
        const allClassName = classNames({
            [`${prefixCls}-multiple`]: multiple,
            [`${prefixCls}-more`]: iconExpanded,
        }, this.getMergedClassNames());
        return (React.createElement("div", Object.assign({}, this.getMergedProps(), { className: allClassName }), renderer ? renderer({
            options: this.options,
            name: this.name,
            dataSet: this.dataSet,
            onConfirm,
            record: this.record,
        }) : (React.createElement(React.Fragment, null,
            React.createElement("div", { className: `${prefixCls}-title` }, labelNode),
            React.createElement("div", { className: `${prefixCls}-content` },
                React.createElement("div", { className: `${prefixCls}-scroll` },
                    React.createElement(Row, null, this.getScreeningOption()))),
            !this.multiple && (React.createElement("div", { className: `${prefixCls}-operation` },
                expandButtonContainer,
                multipleButton)),
            this.multiple && (React.createElement("div", { className: `${prefixCls}-footer` },
                React.createElement(ObserverButton, { onClick: this.handleConfirm }, `${$l('Screening', 'confirm')}`),
                React.createElement(ObserverButton, { onClick: this.handleCancel }, `${$l('Screening', 'cancel')}`)))))));
    }
};
Screening.displayName = 'ScreeningItem';
Screening.defaultProps = {
    suffixCls: 'screening-item',
    multiple: false,
    colProps: {
        span: 4,
    },
};
__decorate([
    observable
], Screening.prototype, "iconExpanded", void 0);
__decorate([
    observable
], Screening.prototype, "observableProps", void 0);
__decorate([
    observable
], Screening.prototype, "screeningMultiple", void 0);
__decorate([
    computed
], Screening.prototype, "record", null);
__decorate([
    computed
], Screening.prototype, "value", null);
__decorate([
    computed
], Screening.prototype, "needExpandButton", null);
__decorate([
    computed
], Screening.prototype, "name", null);
__decorate([
    computed
], Screening.prototype, "primitive", null);
__decorate([
    computed
], Screening.prototype, "field", null);
__decorate([
    autobind
], Screening.prototype, "handleChange", null);
__decorate([
    computed
], Screening.prototype, "options", null);
__decorate([
    computed
], Screening.prototype, "multiple", null);
__decorate([
    computed
], Screening.prototype, "textField", null);
__decorate([
    computed
], Screening.prototype, "valueField", null);
__decorate([
    action
], Screening.prototype, "handleExpanedClick", void 0);
__decorate([
    action
], Screening.prototype, "setValue", null);
__decorate([
    action
], Screening.prototype, "prepareSetValue", null);
__decorate([
    action
], Screening.prototype, "handleMultiple", void 0);
__decorate([
    action
], Screening.prototype, "handleClear", void 0);
Screening = __decorate([
    observer
], Screening);
export default Screening;
